let timeoutId;
const setBannerTimeout = ({ callback = () => {
}, duration = 5e3 } = {}) => {
  timeoutId = setTimeout(() => {
    callback();
  }, duration);
};
const clearBannerTimeout = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
    return;
  }
  console.info("No timeout to clear");
};
const isWindowDefined = () => typeof window !== "undefined";
const isFalsy = (value) => !value;
const isFalsyFilter = (value) => !value || typeof value === "object" || typeof value === "function" || typeof value === "boolean";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clearBannerTimeout,
  isFalsy,
  isFalsyFilter,
  isWindowDefined,
  setBannerTimeout
}, Symbol.toStringTag, { value: "Module" }));
export {
  isWindowDefined as a,
  isFalsy as b,
  isFalsyFilter as c,
  clearBannerTimeout as d,
  index as i,
  setBannerTimeout as s
};
//# sourceMappingURL=index-CzdAPYVv.js.map
